import React, { useEffect, useState } from 'react'
import Banner2 from '../../components/Banner2'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux';
import 'react-phone-input-2/lib/plain.css';
import { createProductInquiry } from '../../features/productInquiry'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import Datepicker from '../../components/Datepicker'
import SelectDropdown from '../../components/SelectDropdown';
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import MobileNumberInput from '../../components/MobileNumberInput';

const PersonalAccident = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [insureList, setInsureList] = useState([{ title: "", name: "", dob: "" }]);
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [errors, setErrors] = useState({});

  const handleInputChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.plan_type)
      newErrors.plan_type = t("validation.selection_required");

    // Validate Members
    insureList.forEach((member, index) => {
      if (!member.title)
        newErrors[`title_${index}`] = t("validation.title_required");

      if (!member.name)
        newErrors[`name_${index}`] = t("validation.name_required");

      if (!member.dob)
        newErrors[`dob_${index}`] = t("validation.dob_required");
    });

    // Corporate Validation
    if (formData.plan_type === "corporate") {
      if (!formData.company_name)
        newErrors.company_name = t("validation.company_required");

      if (!formData.industry)
        newErrors.industry = t("validation.industry_required");

      if (!formData.no_employees)
        newErrors.no_employees = t("validation.invalid_employees");

      if (!formData.policy_expiry_date)
        newErrors.policy_expiry_date = t("validation.expiry_required");
    }

    // Email
    if (!formData.email)
      newErrors.email = t("validation.email_required");
    else if (!emailRegex.test(formData.email))
      newErrors.email = t("validation.email_invalid");

    // Mobile
    if (!formData.mobile_number)
      newErrors.mobile_number = t("validation.phone_required");

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getMaxDOB = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // yyyy-mm-dd format
  };

  const maxDOB = getMaxDOB();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error(t("validation.please_fix_errors"));
      return;
    }

    try {
      const final_data = {
        ...formData,
        member_list: insureList,
      };

      const response = await dispatch(
        createProductInquiry({
          form_data: final_data,
          product_details: JSON.parse(localStorage.getItem("product_details")),
        })
      ).unwrap();

      if (response.success) {
        toast.success(t("success_res"));
        navigate("/");
      }
    } catch (error) {
      toast.error(t("error_res"));
    }
  };


  const handleInsureChange = (name, value, index) => {
    setInsureList((prevList) =>
      prevList.map((insure, i) => (i === index ? { ...insure, [name]: value } : insure))
    );
  };

  //country code
  const [countryCodes, setCountryCodes] = useState([]);
  const [selectedCode, setSelectedCode] = useState("");

  useEffect(() => {
    const codes = Array.from(
      new Map(
        getCountries().map((code) => {
          const dialCode = "+" + getCountryCallingCode(code);
          return [dialCode, { label: dialCode, value: dialCode }];
        })
      ).values()
    ).sort((a, b) => a.value.localeCompare(b.value));
    // console.log(codes, "codes");

    setCountryCodes(codes);
    setSelectedCode(codes[0]);
  }, []);

  return (
    <>
      <Banner2 classList='bg-grey'>
        <Container>
          <Row>
            <Col className='offset-md-3' md={9}>
              <div className='insurance-title'>
                <h3 className='title text-capitalize text-center'>
                  {t('personal_accident.description')}
                </h3>
              </div>
            </Col>

            <Col md={3}>
              <div className='policy-box'>
                <div className='icon-image'>
                  <img
                    src={require('../../assets/SVG/1-30.svg').default}
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <p className='title'>{t('personal_accident.title')}</p>
              </div>
            </Col>

            <Col md={9}>
              <div className='policy-form'>
                <div className='policy-formBox why-us-form'>
                  <Form onSubmit={handleSubmit}>
                    <Row>

                      <Col md={12}>
                        <h5 className='subtitle'>
                          {t('personal_accident.choose_your_plan')}
                        </h5>
                        <div className="flex-content">
                          <div className='form-group custom-checkbox'>
                            <Form.Control type="checkbox"
                              id="plan_type"
                              name="plan_type"
                              value="individual"
                              checked={formData.plan_type === "individual"}
                              onChange={(e) => handleInputChange(e.target.name, e.target.value)} />
                            <label htmlFor="plan_type">{t('personal_accident.form.individual')}</label>

                          </div>
                          <div className='form-group custom-checkbox'>
                            <Form.Control
                              type="checkbox"
                              id="corporate"
                              name="plan_type"
                              value="family"
                              checked={formData.plan_type === "family"}
                              onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                            />{' '}
                            <label htmlFor="corporate">{t('personal_accident.form.family')}</label>
                          </div>
                          {errors.plan_type && (
                            <small className="text-danger">
                              {errors.plan_type}
                            </small>
                          )}
                        </div>
                      </Col>


                      {/* PLAN TYPE */}
                      {/* <Col md={12}>
                        <h5 className='subtitle'>
                          {t('personal_accident.choose_your_plan')}
                        </h5>

                        <div className="flex-content">
                          <div className='form-group custom-checkbox'>
                            <Form.Control
                              type="checkbox"
                              name="plan_type"
                              value="individual"
                              checked={formData.plan_type === "individual"}
                              onChange={(e) =>
                                handleInputChange("plan_type", e.target.value)
                              }
                            />
                            <label>{t('personal_accident.form.individual')}</label>
                          </div>

                          <div className='form-group custom-checkbox'>
                            <Form.Control
                              type="checkbox"
                              name="plan_type"
                              value="family"
                              checked={formData.plan_type === "family"}
                              onChange={(e) =>
                                handleInputChange("plan_type", e.target.value)
                              }
                            />
                            <label>{t('personal_accident.form.family')}</label>
                          </div>
                        </div>

                        {errors.plan_type && (
                          <small className="text-danger">
                            {errors.plan_type}
                          </small>
                        )}
                      </Col> */}

                      {/* MEMBERS */}
                      {insureList.map((insure, index) => (
                        <Col md={12} key={"insure-form-list" + index}>
                          <Row>

                            {/* TITLE */}
                            <Col md={6} lg={4}>
                              <div className='form-group'>
                                <SelectDropdown
                                  name="title"
                                  placeholder={t('personal_accident.form.title.placeholder')}
                                  index={index}
                                  options={[
                                    { value: "mr", label: t('personal_accident.form.title.option1') },
                                    { value: "miss", label: t('personal_accident.form.title.option2') },
                                    { value: "mrs", label: t('personal_accident.form.title.option3') },
                                  ]}
                                  handleOnChange={handleInsureChange}
                                />

                                {errors[`title_${index}`] && (
                                  <small className="text-danger">
                                    {errors[`title_${index}`]}
                                  </small>
                                )}
                              </div>
                            </Col>

                            {/* NAME */}
                            <Col md={6} lg={8}>
                              <div className='form-group'>
                                <Form.Control
                                  type='text'
                                  name='name'
                                  placeholder={t('personal_accident.form.name')}
                                  className="form-control element-style"
                                  onChange={(e) =>
                                    handleInsureChange("name", e.target.value, index)
                                  }
                                  value={insure.name}
                                />

                                {errors[`name_${index}`] && (
                                  <small className="text-danger">
                                    {errors[`name_${index}`]}
                                  </small>
                                )}
                              </div>
                            </Col>

                            {/* DOB (FIXED) */}
                            <Col lg={12} md={12}>
                              <div className="form-group">
                                <Form.Label>
                                  {t("personal_accident.form.dob")}
                                </Form.Label>

                                <Form.Control
                                  type="date"
                                  name="dob"
                                  max={maxDOB}
                                  className="form-control element-style"
                                  value={insure.dob}
                                  onChange={(e) =>
                                    handleInsureChange("dob", e.target.value, index)
                                  }
                                />

                                {errors[`dob_${index}`] && (
                                  <small className="text-danger">
                                    {errors[`dob_${index}`]}
                                  </small>
                                )}
                              </div>
                            </Col>

                            {/* ADD REMOVE */}
                            {formData?.plan_type === "family" &&
                              insureList.length === index + 1 && (
                                <Col className='addbtn' md={12}>
                                  <button
                                    type='button'
                                    className='personal-add-button me-2'
                                    onClick={() =>
                                      setInsureList([
                                        ...insureList,
                                        { title: "", name: "", dob: "" },
                                      ])
                                    }
                                  >
                                    {t('personal_accident.form.add')}
                                  </button>

                                  {insureList.length > 1 && (
                                    <button
                                      type='button'
                                      className='personal-add-button'
                                      onClick={() =>
                                        setInsureList(
                                          insureList.filter((_, i) => i !== index)
                                        )
                                      }
                                    >
                                      {t('personal_accident.form.remove')}
                                    </button>
                                  )}
                                </Col>
                              )}
                          </Row>
                        </Col>
                      ))}

                      {/* CORPORATE */}
                      {formData?.plan_type === "corporate" && (
                        <>
                          <Col md={12}>
                            <div className='form-group'>
                              <Form.Control
                                type='text'
                                name='company_name'
                                placeholder={t('personal_accident.form.company_name')}
                                className="form-control element-style"
                                onChange={(e) =>
                                  handleInputChange("company_name", e.target.value)
                                }
                              />
                              {errors.company_name && (
                                <small className="text-danger">
                                  {errors.company_name}
                                </small>
                              )}
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className='form-group'>
                              <Form.Control
                                type='number'
                                name='industry'
                                placeholder={t('personal_accident.form.industry')}
                                className="form-control element-style"
                                onChange={(e) =>
                                  handleInputChange("industry", e.target.value)
                                }
                              />
                              {errors.industry && (
                                <small className="text-danger">
                                  {errors.industry}
                                </small>
                              )}
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className='form-group'>
                              <Form.Control
                                type='number'
                                name='no_employees'
                                placeholder={t('personal_accident.form.no_employees')}
                                className="form-control element-style"
                                onChange={(e) =>
                                  handleInputChange("no_employees", e.target.value)
                                }
                              />
                              {errors.no_employees && (
                                <small className="text-danger">
                                  {errors.no_employees}
                                </small>
                              )}
                            </div>
                          </Col>
                        </>
                      )}

                      {/* EMAIL */}
                      <Col md={6}>
                        <div className='form-group'>
                          <Form.Control
                            type='email'
                            name='email'
                            placeholder={t('personal_accident.form.email')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange("email", e.target.value)
                            }
                          />
                        </div>

                        {errors.email && (
                          <small className="text-danger">
                            {errors.email}
                          </small>
                        )}
                      </Col>

                      {/* MOBILE */}
                      <Col md={6}>
                        <MobileNumberInput
                          onChange={({ countryCode, number }) => {
                            handleInputChange("country_code", countryCode);
                            handleInputChange("mobile_number", number);
                          }}
                        />

                        {errors.mobile_number && (
                          <small className="text-danger">
                            {errors.mobile_number}
                          </small>
                        )}
                      </Col>

                      {/* SUBMIT */}
                      <Col md={12}>
                        <div className='form-submitbtn'>
                          <button type="submit" className="btn h-btn">
                            {t('personal_accident.form.confirm')}
                          </button>
                        </div>
                      </Col>

                    </Row>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Banner2>
    </>
  );
}

export default PersonalAccident